<template>
  <el-dialog
    :title="this.$t('text.new_area_filter')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    append-to-body
    width="600px"
    v-if="dialogVisible"
  >
    <el-form
      label-width="130px"
      :model="form"
      ref="form"
      :rules="rules"
      :label-position="$root.screenWidth >= 550 ? 'left' : 'top'"
    >
      <el-form-item :label="$t('text.Organisation')" prop="organisation">
        <el-select
          v-model="form.organisation"
          filterable
          disabled
          :placeholder="$t('text.Organisation')"
          class="wp-100"
        >
          <el-option
            v-for="organisation in organisations"
            :key="organisation.OrganisationName.OrganisationId"
            :label="organisation.OrganisationName.Name"
            :value="organisation.OrganisationName.OrganisationId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.area_filter_name')" prop="areaFilterName">
        <el-input
          v-model="form.areaFilterName"
          :placeholder="$t('text.area_filter_name')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.facility')" prop="building">
        <el-select
          v-model="form.building"
          filterable
          :placeholder="$t('text.select')"
          class="wp-100"
        >
          <el-option
            v-for="building in buildings"
            :key="building.BuildingId"
            :label="building.BuildingName"
            :value="building.BuildingId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.area')" prop="area">
        <el-cascader
          class="wp-100"
          :key="Math.random()"
          filterable
          ref="areaSelector"
          :placeholder="$t('text.select')"
          v-model="form.area"
          :options="areaOptions"
          :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
          popper-class="area-poper custom-cascader"
        >
          <template slot="empty">
            <div>
              <li class="el-cascader__empty-text">
                {{
                  form.building
                    ? $t('text.no_data')
                    : $t('text.please_select_facility_first')
                }}
              </li>
            </div>
          </template>
        </el-cascader>
      </el-form-item>
    </el-form>
    <div
      class="filter-summary"
      v-if="form.organisation && form.building && form.area.length"
    >
      <div class="title">{{ $t('text.filter_summary') }}</div>
      <div>
        {{
          $t('text.show_patients_from', {
            patients: $firstLetterCapitalize($store.state.locale.patients)
          })
        }}
        <b>{{ selectedOrganisationName }}</b> {{ $t('text.in') }}
        <b>{{ selectedBuildingName }}</b> {{ $t('text.belonging_to') }}
        <b>
          <span v-for="(floor, index) in selectedFloor" :key="floor.value">{{
            index !== selectedFloor.length - 1
              ? floor.label + ', '
              : floor.label
          }}</span>
        </b>
        {{ $t('text.and') }}
        <b>
          <span v-for="(room, index) in selectedRoom" :key="room.value">{{
            index !== selectedRoom.length - 1 ? room.label + ', ' : room.label
          }}</span
          >.</b
        >
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import _ from 'lodash'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      organisations: this.$store.getters[`user/userOwnedOrganisations`],
      buildings: [],
      areaOptions: [],
      form: {
        areaFilterName: '',
        organisation: this.$store.getters[`user/selecteOrganisationId`],
        building: '',
        area: []
      },
      rules: {
        areaFilterName: [
          {
            required: true,
            message: this.$t('text.please_enter_area_filter_name'),
            trigger: 'blur'
          }
        ],
        organisation: [
          {
            required: true,
            message: this.$t('text.please_select_organisation'),
            trigger: 'blur'
          }
        ],
        building: [
          {
            required: true,
            message: this.$t('text.please_select_facility'),
            trigger: 'blur'
          }
        ],
        area: [
          {
            required: true,
            message: this.$t('text.please_select_floor_and_room'),
            trigger: 'blur'
          }
        ]
      },
      selectedOrganisationName: '',
      selectedBuildingName: '',
      selectedFloor: [],
      selectedRoom: []
    }
  },
  mounted() {
    this.$store.dispatch('filter/getBuildings').then(() => {
      this.buildings = this.buildings.concat(this.$store.state.filter.buildings)
    })
    this.calcSelectedOrganisationName()
  },
  watch: {
    'form.organisation': function(val) {
      if (!val) return
      this.calcSelectedOrganisationName()
    },
    'form.building': function(val, oldVal) {
      if (!val) return
      this.getAreaOptions()
      this.calcSelectedBuildingName()
      if (oldVal) {
        this.form.area = []
      }
    },
    'form.area': function(val) {
      if (val.length === 0) return
      this.calcSelectedArea()
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        areaFilterName: '',
        organisation: this.$store.getters[`user/selecteOrganisationId`],
        building: '',
        area: []
      }
      this.areaOptions = []
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    getAreaOptions() {
      let allFloors = this.buildings.filter(
        building => building.BuildingId === this.form.building
      )
      this.areaOptions = allFloors[0].Floors.map(floor => {
        let children = floor.Rooms.map(room => {
          return {
            ...room,
            value: room.RoomId,
            label: room.RoomNumber
          }
        })
        children.unshift({
          value: 'Room',
          label: this.$t('text.room'),
          children: []
        })
        return {
          ...floor,
          value: floor.FloorId,
          label: floor.FloorName,
          children: children
        }
      })
      this.areaOptions.unshift({
        value: 'Floor',
        label: this.$t('text.floor'),
        children: []
      })
    },
    calcSelectedOrganisationName() {
      this.organisations.forEach(organisation => {
        if (
          organisation.OrganisationName.OrganisationId ===
          this.form.organisation
        ) {
          this.selectedOrganisationName = organisation.OrganisationName.Name
        }
      })
    },
    calcSelectedBuildingName() {
      this.buildings.forEach(building => {
        if (building.BuildingId === this.form.building) {
          this.selectedBuildingName = building.BuildingName
        }
      })
    },
    calcSelectedArea() {
      this.$nextTick(() => {
        this.selectedFloor = []
        this.selectedRoom = []
        let allCheckedNodes = this.$refs.areaSelector.getCheckedNodes(true)
        allCheckedNodes.forEach(node => {
          this.selectedRoom.push({
            label: node.label,
            value: node.value
          })

          this.selectedFloor.push({
            label: node.parent.label,
            value: node.parent.value
          })
          this.selectedFloor = _.uniqWith(this.selectedFloor, _.isEqual)
        })
      })
    },
    submit() {
      let allCheckedNodes = this.$refs.areaSelector.getCheckedNodes()
      let roomIds = allCheckedNodes
        .filter(node => node.level === 2)
        .map(item => item.value)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.SaveAreaDetail({
            BuildingId: this.form.building,
            AreaName: this.form.areaFilterName,
            RoomIds: roomIds
          })
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$store.dispatch('filter/getAreaFilters')
                this.closeDialog()
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
